(function() {
  /*-----------------------------------------------------------------------------/
  / Custom Theme JS
  /-----------------------------------------------------------------------------*/

  // Insert any custom theme js here...

  var $content = $('.product-single__content');

  if(!$content.length) return false;

  var content = $content.html();

  content = content.replace(/^(?:.*)\[description([^\]]+)?\](?:.*)$/gm, '<description$1>');
  content = content.replace(/^(?:.*)\[\/description\](?:.*)$/gm, '</description>');

  $content.html(content);

  var options = [];
  var vals = [];

  $('input[option]').each(function() {
    var $this = $(this);
    var option = $this.attr('option');
    var value = $this.val();
    
    vals.push(value);

    if(options.indexOf(option) > -1) return;

    options.push(option);
  });
  
  var _wood_ = options[0];
  var _size_ = options[1];
  var _teak_ = vals[1];
  var _21x145_ = vals[3];

  var values = {};
  var $size_21x145 = $('input[value="'+_21x145_+'"]').parent();
  var $wood_Teak = $('input[value="'+_teak_+'"]').parent();

  options.map(function(option) {
    values[option] = $('input[option="'+option+'"]:checked').val();

    $('input[option="'+option+'"]').change(function() {
      values[option] = this.value;

      if(product.id == 4556053839946) {
        $size_21x145.toggle(!(option == _wood_ && this.value == _teak_));
        $wood_Teak.toggle(!(option == _size_ && this.value == _21x145_));
      }
      
      showVariantDescription(values);
    });
  });

  showVariantDescription(values);
  
  setTimeout(function() {
	if(product.id == 4556053839946) {
      var wood = $('input[option="'+_wood_+'"]:checked').val();
      var size = $('input[option="'+_size_+'"]:checked').val();

      $size_21x145.toggle(wood != _teak_);
      $wood_Teak.toggle(size != _21x145_);
    }
  });

  var hasDescription = !!$('description').length;
  var $text = $('<div>');

  if(hasDescription) {
    $('description').each(function() {
      var $description = $('<description>');

      $.each(this.attributes, function() {
        if(this.specified) {
          $description.attr(this.name, this.value);
        }
      });

      $(this).contents().each(function() {
        if(this.tagName == 'H6') return false;

        $description.append(this);
      });

      $text.append($description);
    });
  }

  else {
    $('.product-single__content-text').contents().each(function() {
      if(this.tagName == 'H6') return false;

      $text.append(this);
    });
  }

  $('.product-single__form').prepend($text);

  /** Unique tabs using H6 as an anchor **/
  var n = 0;

  $('.product-single__content-text').find('h6').each(function(i) {

    var tabName = $(this).text();
    tabContent = '';

    //check if h6 has text inside
    if ($(this).text() != '') {

      //hide h6
      $(this).hide();
      //combine content between H6 elements
      $(this).nextUntil('h6').each(function() {
        tabContent += this.outerHTML;

        //hide content
        $(this).hide();
      });

      //generate tab HTML
      var $description = $(this).closest('description');

      if(!$description.length) {
        $description = $('.js-accordion');
      }

      $description.append('<a href="#acc-unique-'+ [i] +'" class="product-single__accordion__title js-accordion-trigger"><h4 class="product-single__accordion__title-text">' + tabName + '</h4><span class="product-single__accordion__title-icon icon-fallback"><i class="icon icon--plus" aria-hidden="true"></i><span class="icon-fallback__text">Open tab</span></span></a>');
      $description.append('<div id="acc-unique-'+ [i] +'" class="product-single__accordion__item js-accordion-info"><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></div>');

    } else {	

      //hide empty H6
      $(this).remove();
    }

  });
  
  var _installation_system_ = options[options.length - 2];

  $('input[option="'+_installation_system_+'"]').change(function() {
    $('.installation-system').remove();

    var content =  '<div class="installation-system">';

    if(true || this.value.indexOf('Magnet') > -1) {
      content += '<div><img src="https://cdn.shopify.com/s/files/1/0285/3742/1898/files/The_Magnet_x90.jpg"></div>';
      content += '<p>All the accesories that you will need to build your deck in our patented system are included in this price.</p>';
    } else {
      content += '<div><img src="https://cdn.shopify.com/s/files/1/0285/3742/1898/t/11/assets/own-subtructure.jpg"></div>';
      content += '<p>Choose this if you want to miss our patented system because you have already the substructure. This price will include you the clips and screws to build your deck.</p>';
    }

    content += '</div>';

    $(this).closest('.product-single__swatch').append(content);
  });

  $('input[option="'+_installation_system_+'"]:checked').change();
})();